import { useEffect, useState, useCallback } from 'react'
import { useSessionContext } from '../contexts/SessionContext'
import { getUserPatterns } from '../utils/helpers/supabase.helpers'
import { AgamiPattern } from '../types/supabase'

interface UseExperiencesPatternsOptions {
  enabled?: boolean
}

interface UseExperiencesPatternsReturn {
  patternsList: AgamiPattern[] | null
  isLoading: boolean
  refetch: () => Promise<void>
}

export const useExperiencesPatterns = (
  options: UseExperiencesPatternsOptions = {}
): UseExperiencesPatternsReturn => {
  const { user } = useSessionContext()
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [patternsList, setPatternsList] = useState<AgamiPattern[] | null>(null)
  const { enabled = true } = options

  const fetchPatternsList = useCallback(async (): Promise<void> => {
    if (enabled === false || !user) {
      return
    }

    const { data, error } = await getUserPatterns({ user })

    if (error || !data) {
      setIsLoading(false)
      return
    }

    setPatternsList(data)
    setIsLoading(false)
  }, [user, enabled])

  useEffect(() => {
    if (!user || enabled === false) {
      return
    }

    fetchPatternsList()
  }, [user, enabled, fetchPatternsList])

  return { patternsList, isLoading, refetch: fetchPatternsList }
}
